import { getProductName } from "@/components/history/ProductUtils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ProductSelectorProps {
  selectedProductId: string;
  setSelectedProductId: (id: string) => void;
  filteredProducts: any[];
}

export const ProductSelector = ({
  selectedProductId,
  setSelectedProductId,
  filteredProducts,
}: ProductSelectorProps) => {
  if (filteredProducts.length === 0) {
    return <div className="text-sm text-muted-foreground">Aucun produit trouvé</div>;
  }

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium leading-none">
        Sélectionner un produit
      </label>
      <Select value={selectedProductId} onValueChange={setSelectedProductId}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Sélectionner un produit" />
        </SelectTrigger>
        <SelectContent>
          {filteredProducts.map((item) => (
            <SelectItem key={item.id} value={item.id}>
              {getProductName(item)} - {item.quantity} {item.data.unit || 'unités'}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};